/* Determines if device being used is mobile. */

const isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  if (
    /windows phone/i.test(userAgent) ||
    /android/i.test(userAgent) ||
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
  ) {
    return true
  }
  return false
}

export const DEVICE_INFO = {
  isMobile: isMobile(),
}
